"use strict";

/**
 * @classdesc
 * Aktion zum anzeigen einer Attributtabelle.
 *
 * @class
 * @extents gc.gis.action.GCAbstractAction
 * @memberof gc.gis.action.layer
 * @author Anton Popov <a.popov@brain-scc.de>
 */
gc.gis.action.layer.ShowAttributeTable = function( options )
{
	gc.gis.action.GCAbstractAction.call( this );

	this.func = this.doToggle;
	this.args = [options.layer];
};
gc.gis.action.layer.ShowAttributeTable.prototype = Object.create( gc.gis.action.GCAbstractAction.prototype );

/**
 * @public
 * @method
 * @param {gc.gis.layer.GCVectorLayer} layer TODO
 */
gc.gis.action.layer.ShowAttributeTable.prototype.doToggle = function( layer )
{
	// TODO
};

